import Modal from '../_modal';
import DigestTypeSettings from './_digest_type_settings';

const DigestSettingsModal = ({
  digest,
  activeDigestType,
  digestTypes,
  visibilityGroups,
  multipleDigestsEnabled,
  activeDigestTypeIsNew,
  onClose,
  onCancel,
  digestGet,
  digestTypeUpdate,
  confirm
}) => {
  return (
    <Modal
      header={false}
      padded={false}
      extraBodyClass="with-overflow-scroll"
      extraModalClass="digest-settings-modal-container"
      basic={true}
      onClose={onClose}
      hideCloseButton={true}
      closeOnOutsideClick={false}>
      <DigestTypeSettings
        digest={digest}
        activeDigestType={activeDigestType}
        activeDigestTypeIsNew={activeDigestTypeIsNew}
        digestTypes={digestTypes}
        visibilityGroups={visibilityGroups}
        multipleDigestsEnabled={multipleDigestsEnabled}
        onClose={onClose}
        onCancel={onCancel}
        digestTypeUpdate={digestTypeUpdate}
        digestGet={digestGet}
        confirm={confirm}
        showDoneButton={true}
        showNameSection={true} />
    </Modal>
  );
};

DigestSettingsModal.propTypes = {
  digest: PropTypes.object,
  activeDigestType: PropTypes.object,
  digestTypes: PropTypes.arrayOf(PropTypes.object),
  visibilityGroups: PropTypes.arrayOf(PropTypes.object),
  multipleDigestsEnabled: PropTypes.bool,
  activeDigestTypeIsNew: PropTypes.bool,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  digestTypeUpdate: PropTypes.func,
  digestGet: PropTypes.func,
  confirm: PropTypes.func
};

DigestSettingsModal.defaultProps = {
  digest: null,
  activeDigestType: null,
  digestTypes: [],
  visibilityGroups: [],
  multipleDigestsEnabled: false,
  activeDigestTypeIsNew: false,
  onClose() {},
  onCancel: null,
  digestTypeUpdate() {},
  digestGet() {},
  confirm() {}
};

export default DigestSettingsModal;
